module.exports = __webpack_public_path__ + "img/Twitter_Logo_Blue.d0f0f494.svg";